import { render } from "./ShopModalReservation.vue?vue&type=template&id=23480731"
import script from "./ShopModalReservation.vue?vue&type=script&lang=js"
export * from "./ShopModalReservation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__